// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Input from '@mui/material/Input'
import type { VitrineProduct } from './vitrineProductTypes'
import type { Station } from '../../station/stationTypes'
import { updateVitrineProductWastePercent, availableVitrineProductsQuery } from './vitrineProductQueries'
import { Mutation } from 'react-apollo'
import withActiveStation from '../../station/withActiveStation'
import css from './wastePercentageTable.css'
type Props = {
  index: number
  data: VitrineProduct
  onEdit: (...args: Array<any>) => any
  activeStation: Station
}

const updateCacheOnUpdate = (cache: any, { data: { updateVitrineProductWastePercent } }: any, stationId: string) => {
  const { availableVitrineProducts } = cache.readQuery({
    query: availableVitrineProductsQuery,
    variables: {
      stationId,
    },
  })
  cache.writeQuery({
    query: availableVitrineProductsQuery,
    variables: {
      stationId,
    },
    data: {
      availableVitrineProducts: [
        ...availableVitrineProducts.map((vitrineProduct) => {
          return vitrineProduct.id === updateVitrineProductWastePercent.id
            ? updateVitrineProductWastePercent
            : vitrineProduct
        }),
      ],
    },
  })
}

@withActiveStation
class WastePercentageRow extends React.Component<Props> {
  onSubmit = (e: React.SyntheticEvent<HTMLInputElement>, onMutate: (...args: Array<any>) => any, id: string) => {
    const {
      activeStation: { id: stationId },
    } = this.props

    const parsedValue = +e.target.value

    onMutate({
      variables: {
        id,
        stationId,
        wastePercent: isNaN(parsedValue) ? 0 : parsedValue,
      },
      update: (cache: any, mutationResult: any) => updateCacheOnUpdate(cache, mutationResult, stationId),
    })
  }

  render() {
    const {
      data: { id, name, wastePercent },
      index,
      onEdit,
    } = this.props
    return (
      <Mutation mutation={updateVitrineProductWastePercent}>
        {(onMutate) => (
          <TableRow>
            <TableCell className={css.tableCell}>{name}</TableCell>
            <TableCell className={css.tableCell}>
              <Input
                type='number'
                value={wastePercent || ''}
                onChange={(e) => onEdit(e, index)}
                onBlur={(e) => this.onSubmit(e, onMutate, id)}
              />
            </TableCell>
          </TableRow>
        )}
      </Mutation>
    )
  }
}

export default WastePercentageRow
